import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/lib/stores/authStore';
import HeroSection from '@/components/landing/HeroSection';
import AboutSection from '@/components/landing/AboutSection';
import PlayFreeSection from '@/components/landing/PlayFreeSection';
import FeaturesSection from '@/components/landing/FeaturesSection';
import CtaSection from '@/components/landing/CtaSection';

export default function LandingPage() {
  const { isLoggedIn, isLoading, hasHydrated } = useAuthStore();

  if (!hasHydrated || isLoading) {
    return null;
  }

  if (isLoggedIn) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <>
      <HeroSection />
      <AboutSection />
      <PlayFreeSection />
      <FeaturesSection />
      <CtaSection />
    </>
  );
}
